import React from "react";
import type { RenderSiteProps } from "./RenderSite";

export const Features: React.FC<RenderSiteProps> = (props) => {
  if (!props.site.services) {
    return null;
  }
  const { color, color_weight, textColor } = props.site;
  return (
    <section
      id="features"
      className={`py-6 bg-gradient-to-b from-${color}-${color_weight} to-${color}-${color_weight}`}
    >
      {props.site.services.title && (
        <h2
          className={`text-${textColor} text-center py-8 text-2xl font-bold first-letter:uppercase`}
        >
          {props.site.services.title}
        </h2>
      )}

      <div className="m-auto max-w-7xl px-6 grid grid-cols-1 lg:grid-cols-2 gap-6 justify-items-center">
        {props.site.services?.items?.map((item, index) => (
          <article
            className="p-6 w-full max-w-xl"
            key={item.id || `service-${index}`}
          >
            <h3
              className={`text-xl font-semibold text-${textColor} mb-2 text-center lg:text-left first-letter:uppercase`}
            >
              {item.title}
            </h3>
            {item.description?.split("\n").map((itemDescription, index) => (
              <p
                key={`${item.id}-${index}`}
                className={`text-${textColor} text-center lg:text-left first-letter:uppercase`}
              >
                {itemDescription}
              </p>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
};
